import { render, staticRenderFns } from "./NotificationsToast.vue?vue&type=template&id=2250135d&"
import script from "./NotificationsToast.vue?vue&type=script&lang=js&"
export * from "./NotificationsToast.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports